import React, { useContext } from "react";
import style from "../../Vote/index.module.scss";
import { Spin } from "antd";
import CustomEmpty from "../../../../components/CustomEmpty";
import useRequest from "../../../../Utils/useRequest";
import { getMeetingActivityList } from "../service";
import { CourseContext } from "../../Store";
import MeetingListItem from "../Components/ListItem";

const Index = () => {
    const { course, basename } = useContext(CourseContext);
    const [data, { loading }, reload] = useRequest(
        () => getMeetingActivityList({ weekTimeId: course.weekTimeId }),
        {},
        [basename]
    );
    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    会议活动（{data?.length || 0}）
                </div>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <MeetingListItem
                        key={item.meetingId}
                        reload={reload}
                        data={item}
                    />
                ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
};

export default Index;
